var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.9,
    height: 61.9,
    viewBox: "0 0 61.9 61.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12944",
    d: "M7.6 40.079a1.109 1.109 0 0 1-.326-.052 1.036 1.036 0 0 1-.706-.98v-7.222H3.47a3.1 3.1 0 0 1-3.1-3.1V3.97a3.1 3.1 0 0 1 3.1-3.1h30.95a3.1 3.1 0 0 1 3.1 3.1v10.317a1.032 1.032 0 1 1-2.063 0V3.97a1.035 1.035 0 0 0-1.037-1.032H3.47A1.035 1.035 0 0 0 2.438 3.97v24.76a1.035 1.035 0 0 0 1.032 1.032H7.6a1.032 1.032 0 0 1 1.032 1.032v5.158l4.333-5.777a1.031 1.031 0 0 1 .825-.413h2.06a1.032 1.032 0 0 1 0 2.063H14.3l-5.88 7.841a1.028 1.028 0 0 1-.82.413z",
    transform: "translate(-.375 -.875)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12945",
    d: "M13.222 19.813h-6.19a1.032 1.032 0 1 1 0-2.063h6.19a1.032 1.032 0 1 1 0 2.063z",
    transform: "translate(.19 .82)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12946",
    d: "M28.222 16.063h-6.19a1.032 1.032 0 1 1 0-2.063h6.19a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(1.697 .443)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12947",
    d: "M19.412 16.063H7.032a1.032 1.032 0 1 1 0-2.063h12.38a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(.19 .443)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12948",
    d: "M29.728 12.313H7.032a1.032 1.032 0 1 1 0-2.063h22.7a1.032 1.032 0 1 1 0 2.063z",
    transform: "translate(.19 .067)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12949",
    d: "M53.359 61.834a1.028 1.028 0 0 1-.825-.413l-5.88-7.841H20.345a3.1 3.1 0 0 1-3.1-3.1V23.662a3.1 3.1 0 0 1 3.1-3.1h10.317a1.032 1.032 0 0 1 0 2.063H20.345a1.035 1.035 0 0 0-1.032 1.032v26.828a1.035 1.035 0 0 0 1.032 1.032h26.824a1.031 1.031 0 0 1 .825.413l4.333 5.777v-5.158a1.032 1.032 0 0 1 1.032-1.032h4.127a1.035 1.035 0 0 0 1.032-1.032V23.662a1.035 1.035 0 0 0-1.032-1.032H46.137v3.1a1.032 1.032 0 0 1-1.587.869L33.2 19.372a1.032 1.032 0 0 1 0-1.739l11.35-7.222a1.032 1.032 0 0 1 1.587.871v3.1h7.222a1.032 1.032 0 0 1 0 2.063h-8.254a1.032 1.032 0 0 1-1.032-1.032v-2.252L35.68 18.5l8.394 5.342V21.6a1.032 1.032 0 0 1 1.032-1.032h12.38a3.1 3.1 0 0 1 3.1 3.1v26.817a3.1 3.1 0 0 1-3.1 3.1h-3.1V60.8a1.036 1.036 0 0 1-.706.98 1.106 1.106 0 0 1-.321.054z",
    transform: "translate(1.32 .067)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12950",
    d: "M36.287 38.563h-12.38a1.032 1.032 0 1 1 0-2.063h12.38a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(1.885 2.704)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12951",
    d: "M30.1 34.813h-6.19a1.032 1.032 0 1 1 0-2.063h6.19a1.032 1.032 0 1 1 0 2.063z",
    transform: "translate(1.885 2.327)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12952",
    d: "M50.91 31.063h-8.253a1.032 1.032 0 1 1 0-2.063h8.253a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(3.769 1.95)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12953",
    d: "M51.852 34.813h-18.57a1.032 1.032 0 0 1 0-2.063h18.57a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(2.827 2.327)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12954",
    d: "M40.413 31.063H23.907a1.032 1.032 0 1 1 0-2.063h16.506a1.032 1.032 0 0 1 0 2.063z",
    transform: "translate(1.885 1.95)",
    style: {
      fill: "#d24350"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceFeedback);
export default __webpack_public_path__ + "static/media/experience-feedback.dcc96e055e338123e46f28e1c554b9b0.svg";
export { ForwardRef as ReactComponent };